import userInfo from "../../function/userInfo";
import i18n from "../../locales/i18n";
import * as API from "../ApiConfig";

export default {
  DoGetRevenueExpenseSummary(year) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      year: year,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetRevenueAndExpenseSummary", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoSummaryInvoiceRemainPayment(financeTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      financeTypeId: financeTypeId,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetSummaryInvoiceRemainPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSummaryDepositRemainPayment(financeTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      financeTypeId: financeTypeId,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetSummaryDepositRemainPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSummaryDebitNoteRemainPayment(financeTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      financeTypeId: financeTypeId,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetSummaryDebitNoteRemainPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetRevenueProductSummary(typeSelectOption) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      date: new Date(),
      dashboardSelectOptionTypeId: typeSelectOption,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetRevenueProductSummary", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetExpenseProductSummary(typeSelectOption) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      date: new Date(),
      dashboardSelectOptionTypeId: typeSelectOption,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetExpenseProductSummary", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetRevenueContactSummary(typeSelectOption) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      date: new Date(),
      dashboardSelectOptionTypeId: typeSelectOption,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetRevenueContactSummary", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetExpenseContactSummary(typeSelectOption) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      date: new Date(),
      dashboardSelectOptionTypeId: typeSelectOption,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetExpenseContactSummary", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetRevenueAccountSummary(typeSelectOption) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      date: new Date(),
      dashboardSelectOptionTypeId: typeSelectOption,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetRevenueAccountSummary", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetExpenseAccountSummary(typeSelectOption) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      date: new Date(),
      dashboardSelectOptionTypeId: typeSelectOption,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetExpenseAccountSummary", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetFinanceSummary(typeSelectOption) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      date: new Date(),
      dashboardSelectOptionTypeId: typeSelectOption,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetFinanceSummary", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetRemainPaymentSummaryByPeriodType(_payload) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      financeTypeId: _payload.financeTypeId,
      invoiceRemainPaymentSummaryPeriodTypeId: _payload.invoiceRemainPaymentSummaryPeriodTypeId,
      fromDate: _payload.fromDate,
      toDate: _payload.toDate,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetRemainPaymentSummaryByPeriodType", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetContactDashboardSummary(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      dashboardSelectOptionTypeId: input.selectMonth,
      contactId: input.contactId,
      financeTypeId: input.financeTypeId,
      language: i18n.locale,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetContactDashboardSummary", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
};
